import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcList = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M9.85 4.9a1.1 1.1 0 0 0 0 2.2H19.9a1.1 1.1 0 0 0 0-2.2H9.85ZM8.75 12a1.1 1.1 0 0 1 1.1-1.1H19.9a1.1 1.1 0 0 1 0 2.2H9.85a1.1 1.1 0 0 1-1.1-1.1Zm0 6a1.1 1.1 0 0 1 1.1-1.1H19.9a1.1 1.1 0 0 1 0 2.2H9.85a1.1 1.1 0 0 1-1.1-1.1Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M4.75 7.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM6.5 12A1.75 1.75 0 1 1 3 12a1.75 1.75 0 0 1 3.5 0Zm0 6A1.75 1.75 0 1 1 3 18a1.75 1.75 0 0 1 3.5 0Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcList");

export { IcList };
//# sourceMappingURL=ic-list.js.map
